import * as React from 'react';
import {
  ApplicationViewList,
  type ApplicationViewListProps,
  type TableColumns,
  type FilterFields,
} from '../Application/components/ApplicationViewList';
import { facultyFullListFilter } from '../Assessment/components/filters';
import { type DepartmentType } from '../Application/graphql';
import { useAuth } from '../../contexts';

export const FacultyScholarshipManagementList: React.FunctionComponent = () => {
  const { user } = useAuth();
  const facultyDepartments = user?.userInfo?.rightFRCDepartmentChairList ?? [];

  const visibleFilters: FilterFields[] = React.useMemo(
    () => [
      'entryYear',
      'department',
      'academicProgramme',
      'programmeType',
      'scholarshipAppliedByApplicant',
      'hkpfsNo',
      'validHKPFS',
      'fundingScheme',
      'fundingSchemeStatus',
      'applicantSurname',
      'applicantGivenName',
      'applicationEmail',
      'applicationNo',
      'applicationStatus',
    ],
    [],
  );
  const filterParamFunctions = {
    department: (department: DepartmentType[]) => {
      return department.filter(department => {
        return facultyDepartments.includes(department.value);
      });
    },
  };
  const listFilter = facultyFullListFilter();
  const visibleColumns: TableColumns[] = React.useMemo(
    () => [
      'applicationNo',
      'applicantName',
      'department',
      'entryYear',
      'applyProgramme',
      'confirmedChiefSupervisor',
      'scholarshipApplications',
      'nominatedFundings',
      'applicationStatus',
    ],
    [],
  );
  const filterProps: ApplicationViewListProps['filterProps'] = {
    visibleFilterFields: visibleFilters,
    filterParamFunctions,
  };
  const tableProps: ApplicationViewListProps['tableProps'] = {
    initialVisibleColumns: visibleColumns,
    listFilter,
  };

  return (
    <ApplicationViewList tableProps={tableProps} filterProps={filterProps} />
  );
};
